import http from './utils';

const opinionPrefix = '/api/v1/opinion_pc';

/**
 * 多游戏筛选器条件（取并集）
 * 使用 opinion/filter/cond 端点，但传 games 数组参数（而非单个 gameInfo）
 * 后端根据 games 参数自动走多游戏取并集逻辑
 */
export const getMultiGamesCond: (payload: any) => Promise<any> = payload => {
  return http({
    url: `${opinionPrefix}/filter/multi_games_cond`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 多游戏评论聚合查询
 * 替代 getFeedsComments 的单游戏模式
 */
export const getMultiGamesComments: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${opinionPrefix}/feeds/multi_games_comments`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 多游戏评论指标最大值查询
 * 替代 getFeedsMaxMetric / getCommunityVideoMaxMetric 的单游戏模式
 * 用于 table 列进度条的 max 值
 */
export const getMultiGamesMaxMetric: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${opinionPrefix}/feeds/multi_games_max_metric`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
